import { Button, Stack, Typography } from '@mui/material';
import { ImageWithFallback } from 'components/ImageWithFallback';
import { tenantInfoState } from 'modules/application/atoms';
import { Product } from 'modules/contract/types';
import React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { displayProductModelAndSku } from 'utils/product';

interface LineItemProductProps {
  product: Product,
  completeStep?: () => void
}

export const LineItemProduct: React.FC<LineItemProductProps> = ({ product, completeStep }) => {
  const { formatMessage } = useIntl();
  const tenantInfo = useRecoilValue(tenantInfoState);

  const onItemSelected = () => {
    completeStep && completeStep();
  };

  return (
    <Stack direction='row' gap={2} >
      <ImageWithFallback
        height={100}
        width={100}
        src={`/${tenantInfo.identifier}/api/products/${product.id}/image.png`} />
      <Stack flexGrow={1}>
        <Stack flexGrow={1}>
          <Typography fontWeight={500}>
            {product.name}
          </Typography>
          <Typography variant='caption' color='text.secondary' fontWeight={500}>
            {displayProductModelAndSku(product)}
          </Typography>
        </Stack>
        {completeStep && (
          <Stack alignItems='flex-end' direction='column-reverse'>
            <Button onClick={onItemSelected} variant='contained'>
              {formatMessage({ id: 'LineItemArticle.SelectButton', defaultMessage: 'select' })}
            </Button>
          </Stack>
        )}
      </Stack>
    </Stack >
  );
};